import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../components/auth/AuthProvider';

export const useRedirectIfLoggedIn = () => {
  const { session } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (session) {
      navigate('/dashboard', { replace: true });
    }
  }, [session, navigate]);
};

export const useRequireAuth = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  const { loading, session, user } = auth;

  useEffect(() => {
    // Only check authentication after loading is complete
    if (!loading && !session) {
      // Add a small delay to allow for OAuth processing
      const timer = setTimeout(() => {
        // Double-check that we still don't have a session
        if (!auth.session) {
          // If there's no session, redirect to login page
          navigate('/login', { replace: true });
        }
      }, 300);
      
      return () => clearTimeout(timer);
    }
  }, [navigate, loading, session, auth.session]);

  // Return the auth object for convenience
  return auth;
};